import styled from 'styled-components';
import { rem } from 'polished';
import { media, FlexItem } from 'core/layout';
import { colors } from 'core/theme';

export const FixedTop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 201;

  @media print {
    position: static;
  }
`;

export const PrintLogo = styled.div`
  display: none;

  @media print {
    display: block;
    font-size: 2rem;
  }
`;

export const StyledHeader = styled.header`
  background-color: ${colors.background};
  border-bottom: 1px solid ${colors.hairline};
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.07), 0 1px 2px 0 rgba(0,0,0,0.06), 0 1px 3px 0 rgba(0,0,0,0.1);
  color: ${colors.subtleText};

  display: flex;
  flex-direction: column;

  & > div:first-child {
    display: flex;
    flex: 1 0 auto;

    min-height: ${rem(65)};

    & > div:not(${PrintLogo}) {
      flex: 1 0 auto;
      margin: 0;

      ${media.tablet`
        display: flex;
      `};
    }
  };

  @media (max-width: 459px) {
    & > div:first-child {
      padding: 0;
    }
  }

  @media print {
    border-bottom: none;
    box-shadow: none;
    padding-top: 2rem;

    & > div > *:not(${PrintLogo}) {
      display: none !important;
    }
  }
`;

export const MenuWrapper = FlexItem.extend`
  border-right: 1px solid ${colors.hairline};

  padding-top: 0;
  display: flex;
  align-items: center;

  @media (max-width: 459px) {
    flex: 0;
    padding-left: 0;

    button {
      transform: none;
    }
  }
`;

export const MainWrapper = FlexItem.extend`
  padding-top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1 ${(9/12) * 100}%;

  @media (max-width: 459px) {
    flex: 0;
    padding-left: 0;
  }

  ${media.tablet`
    flex: 1 1 ${(10/12) * 100}%;
  `};

  & > div {
    display: flex;
  }
`;

export const SearchWrapper = FlexItem.extend`
  padding-top: 0;

  & i {
    color: ${colors.secondary};
  }

  & button {
    white-space: nowrap;
  }

  flex: 0 0 ${(2/12) * 100}%;

  @media (max-width: 459px) {
    flex: 0;
    padding-left: 0;
  }

  ${media.tablet`
    flex: 0 0 ${(1/12) * 100}%;
  `};
`;

export const BorderContainer = styled.div`
  border-left: 1px solid ${colors.hairline};
  height: 100%;
  padding-left: 0.5em;

  display: flex;
  align-items: center;

  @media (max-width: 459px) {
    padding-left: 0;
  }
`;

export const LeftGroup = styled.div`
  a {
    display: block;
    padding: 0.75em;
    transform: translateX(-0.75em);

    & > * {
      pointer-events: none;
    }

    ${media.tablet`
      transform: none;
    `};
  }
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/modules/Header/styled.js